
    import { mapActions } from 'vuex'
    import { ELECTRON_BUS } from '../../store/modulesNames'
    import {
        ACT_ELECTRON_BUS_TOGGLE_WINDOW_ON_TOP,
    } from '../../store/actionsTypes'

    import SelectChatToSendMsg from './SelectChatToSendMsg.vue'

    import { WINDOW_NAMES } from '../../../electron/constants'

    export default {
        name: "AddConfMembers",
        extends: SelectChatToSendMsg,
        mounted () {
            this[ACT_ELECTRON_BUS_TOGGLE_WINDOW_ON_TOP]({windowId: WINDOW_NAMES.CONF, payload: {onTop: false}})
        },
        beforeDestroy () {
            this[ACT_ELECTRON_BUS_TOGGLE_WINDOW_ON_TOP]({windowId: WINDOW_NAMES.CONF, payload: {onTop: true}})
        },
        computed: {
            msg() {
                let { outText, entities } = this.extractInputTextFormat(this.props.inviteText)
                return {dataType: 'data', data: JSON.stringify({ type: 'text', text: outText, entities })}
            },
            okText() { return this.$t('videomost.conf-members-invite') }
        },
        methods: {
            ...mapActions(ELECTRON_BUS, [ACT_ELECTRON_BUS_TOGGLE_WINDOW_ON_TOP])
        },
    }
